/**
 * Datas "de calendário" (YYYY-MM-DD) sempre no fuso local.
 *
 * `d.toISOString().slice(0, 10)` usa UTC — depois das 21h no Brasil o
 * "hoje" vira amanhã. E `new Date('YYYY-MM-DD')` é interpretado como
 * meia-noite UTC, então formatar isso no fuso local mostra o dia anterior.
 * Use estas funções em filtros de período e rótulos de relatório.
 */

function doisDigitos(n: number): string {
  return String(n).padStart(2, '0');
}

/** `Date` → "YYYY-MM-DD" usando o dia local (não UTC). */
export function isoDataLocal(d: Date): string {
  return `${d.getFullYear()}-${doisDigitos(d.getMonth() + 1)}-${doisDigitos(d.getDate())}`;
}

/**
 * "YYYY-MM-DD" → "dd/mm/aaaa" sem passar por `Date` (nada de fuso).
 * Devolve '' para entrada vazia ou fora do formato.
 */
export function formatarDataIso(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
}

/** "YYYY-MM-DD" → `Date` à meia-noite local. `null` se inválida. */
export function dataLocalDeIso(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '');
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}
